var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRegistrationBottomBlobGreen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2015.414,
    height: 1771.397,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1855.17 492.5c-49-70.56-114.887-105.02-144.55-120.115-204.196-103.914-377.914 11.285-646.655 37.653-420.521 41.26-552.524-186.124-714.775-83.442-215.948 136.668-243.304 704.796 36.198 1002.461 354.233 377.249 1113.658 226.683 1385.499-162.112 112.617-161.07 221.316-477.114 84.279-674.447",
    fill: "#29f5b2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegistrationBottomBlobGreen);
export default __webpack_public_path__ + "static/media/registration-bottom-blob-green.5bac7822fc0ca2901620814a0c759266.svg";
export { ForwardRef as ReactComponent };